import {Button, Card, Col, Divider, Form, Input, message, Row, Space, Spin} from "antd";
import {ComplaintRequestDto} from "../../dto/ComplaintRequestDto";
import customerChangeRequestService from "../../service/customerChangeRequestService";
import ErrorHandler from "../../util/ErrorHandler";
import {useState} from "react";
import modal from "antd/es/modal";
import {ExclamationCircleOutlined} from "@ant-design/icons";

const {TextArea} = Input;

interface ComplaintProps {
    cin: string
}

const ComplaintsRequestComp = (props: ComplaintProps) => {
    const [form] = Form.useForm();
    const [isLoading, setLoading] = useState<boolean>(false)

    const submitComplaint = () => {
        form.validateFields().then(() => {
            modal.confirm({
                title: 'Confirm',
                icon: <ExclamationCircleOutlined/>,
                content: `Are you sure?, Do you want to lodge a complaint?`,
                okText: 'Yes',
                cancelText: 'No',
                className: 'confirm-dialog-box',
                okButtonProps: {style: {background: '#FF7400'}},
                onOk() {

                    setLoading(true)
                    let complaintRequestDto: ComplaintRequestDto = form.getFieldsValue()

                    customerChangeRequestService.submitComplaintRequest(complaintRequestDto, props.cin).then((res) => {
                        if (res.data.results) {
                            message.success("Complaint submitted successfully")
                            setLoading(false)
                            form.resetFields()
                        } else {
                            message.error("Complaint submission failure")
                            setLoading(false)
                        }
                    }, (reason) => {
                        ErrorHandler.handleError(reason);
                        setLoading(false)

                    })


                },
                onCancel() {

                }
            });
        }).catch(() => {

        })

    }
    return (
        <>
            <Spin spinning={isLoading}>
                <Row gutter={[24, 12]}>

                    <Col span={24}>
                        <Card title="Complaints">
                            <Form
                                className='form-input'
                                layout={"vertical"}
                                form={form}
                            >
                                <Row gutter={[12, 0]}>
                                    <Col span={24}>
                                        <Form.Item
                                            label="Enter your complaint"
                                            name={"complaint"}
                                            rules={[
                                                {required: true, message: 'Please enter complaint'},
                                                {whitespace: true, message: 'Cannot contain whitespaces'},
                                                {max: 256, message: 'The maximum length is 256 characters'},
                                            ]}>
                                            <TextArea rows={4}/>
                                        </Form.Item>
                                    </Col>
                                </Row>
                            </Form>
                        </Card>
                    </Col>
                    <Col span={24}>
                        <Divider style={{marginBottom: 12}}></Divider>
                    </Col>
                    <Col span={24}>
                        <Space style={{float: 'right'}}>
                            {/*<Button size={'large'}*/}
                            {/*        style={{*/}
                            {/*            width: 120,*/}
                            {/*            marginRight: 8*/}
                            {/*        }}>Cancel</Button>*/}
                            <Button size={'large'} type="success"
                                    style={{
                                        width: 120,
                                        background: "#FF7400",
                                        color: "white",
                                    }} onClick={submitComplaint}>Submit</Button>
                        </Space>
                    </Col>
                </Row>
            </Spin>
        </>
    )
}
export default ComplaintsRequestComp;